
import {
    SELECT_TYPE,
    SELECT_SIZE,
    SELECT_COLOUR,
    SELECT_QUANTITY
} from 'Actions/shirt';

const initialState = {
    type: "",
    size: "",
    colour: "",
    quantity: 0
}

export default function shirt(state = initialState, action) {
    switch (action.type) {
        case SELECT_TYPE:
            return { ...state, type: action.shirt_type };
        case SELECT_SIZE:
            return { ...state, size: action.size };
        case SELECT_COLOUR:
            return { ...state, colour: action.colour };
        case SELECT_QUANTITY:
            return { ...state, quantity: action.quantity };
        default:
            return state;
    }
};